// @ts-nocheck

/**
 * * `performer` - Performer
 * `describer` - Describer
 * `comprehender` - Comprehender
 */
export type ReaderProfileParentReadingStyleEnum =
  typeof ReaderProfileParentReadingStyleEnum[keyof typeof ReaderProfileParentReadingStyleEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReaderProfileParentReadingStyleEnum = {
  performer: "performer",
  describer: "describer",
  comprehender: "comprehender",
} as const;
